import React from 'react';
import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import { IconTile } from '@atlaskit/icon';
import LinkIcon from '@atlaskit/icon/core/migration/link--link-filled';
import { fg } from '@atlaskit/platform-feature-flags';
import Tooltip from '@atlaskit/tooltip';
import { messages } from './messages';
export var LinkedFieldIcon = function LinkedFieldIcon(_ref) {
  var fieldName = _ref.fieldName;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var message = fieldName ? formatMessage(messages.tooltip, {
    fieldName: fieldName
  }) : formatMessage(messages.unknownField);
  return /*#__PURE__*/React.createElement(Tooltip, {
    position: "top",
    content: message
  }, function (tooltipProps) {
    return /*#__PURE__*/React.createElement("span", tooltipProps, fg('platform-visual-refresh-icons') ? /*#__PURE__*/React.createElement(IconTile, {
      size: "16",
      label: '',
      icon: LinkIcon,
      appearance: "grayBold",
      shape: "circle"
    }) : /*#__PURE__*/React.createElement(LinkIcon, {
      color: "currentColor",
      LEGACY_size: "small",
      label: "Linked field"
    }));
  });
};